import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiBannerComponent } from './multi-banner.component';
import { BannerComponent } from './banner.component';
import { TagTextModule } from '../tag-text/tag-text.module';
import {AdsBannersModule} from "../ads-banners/ads-banners.module";
import { TextModule } from "../text/text.module";
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { LoaderModule } from '@shopping-angular-components/loader';

@NgModule({
  declarations: [
    MultiBannerComponent,
    BannerComponent
  ],
  imports: [
    CommonModule,
    TagTextModule,
    AdsBannersModule,
    TextModule,
    SliderProModule,
    LoaderModule
  ],
  exports: [MultiBannerComponent]
})
export class MultiBannerModule { }
